  import axios from 'axios'

  import config from '../../config';

  function getUrlFromDomain(domain: string) {
    if (!domain || domain.length == 0) {
      return '';
    }

    // domain shouldn't contain 'https://' but url will
    const httpsProvided : boolean = domain.toLowerCase().startsWith('https://')
    return httpsProvided ? domain : 'https://' + domain
  }

  function getOrCreateClientId(AAD: any, baseUrl: string) {

    const key = 'client-id';

    let env = config.env;
    console.log({env, AAD, baseUrl});

    if (AAD) { // will be called if app in Teams
      const ret = AAD + '-AAD-' + env
      console.log('Using AAD ID:', ret);
      localStorage.setItem(key, ret);
      return ret;
    }

    // for testing outside Teams
    let id = localStorage.getItem(key);
    console.log('Existing ID:', id);
    if (!id) {
      id = crypto.randomUUID() + '-GUID';
      localStorage.setItem(key, id);
      console.log('Generated new ID:', id);
    }
    return id;
  }
  
  const sendUrl = (url : string, userId: any, baseUrl: string) => {
    return () => {
      if (url && url.length > 1) {
        let data = { id: userId.current, value: url}
        axios.post(baseUrl, data)
          .then((response) => {
            console.log('Sent url update ' + response.data);
          })
          .catch((error) => {
            console.error('Error sending url:', error);
          });

        return;
      }
      else {
        console.log('Base URL is not defined. Skipping sending URL to external service.');
        return;
      }
    }
  }

  const getUrl = async (fullUrl: string): Promise<string | null> => {
      if (fullUrl.length > 1) {
        const response = await axios.get(fullUrl);
        if (!response) {
            return null;
        }
        console.log('Response data:', response.data);
        const url = response.data;
        return url;
      } else {
        return null;
      }
  }

  export default    
  {
    getUrlFromDomain,
    getOrCreateClientId,
    sendUrl,
    getUrl
  }
        

